var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTurbine = function SvgTurbine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBED",
    d: "M60 136c23.196 0 42-2.686 42-6s-18.804-6-42-6-42 2.686-42 6 18.804 6 42 6",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD7DC",
    d: "m66.837 129.394-5.85-69.82h-3.062l-2.808 69.82s3.452 1.119 11.72 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M60 52.874s38.668 29.203 44.318 28.159-30.033-28.615-30.033-28.615-10.681-1.746-14.285.456"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m95.34 69.34-4.09 4.819a90 90 0 0 0 8.342 4.948l2.401-3.181c-1.672-1.88-4.02-4.167-6.652-6.585"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M57.994 53.714s-41.745 24.82-42.895 30.373 37.693-17 37.693-17 5.862-9.18 5.202-13.373"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m28.747 80.057-2.807-5.833a96 96 0 0 0-7.936 6.225l1.97 3.54c2.416-.931 5.464-2.329 8.773-3.932"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M59.62 52.738s4.56-48.136.933-52.445c-3.626-4.31-8.365 40.401-8.365 40.401s3.841 10.087 7.432 12.044"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m56.094 13.547 5.828 1.102a89 89 0 0 0-.24-9.284l-3.691-.482a127 127 0 0 0-1.897 8.664"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M61.14 46.881h-2.763a3.8 3.8 0 0 0-1.478.24c-.472.178-.905.45-1.275.798-.37.35-.668.77-.878 1.237s-.329.972-.348 1.486v2.011l-.257 8.875 10.443-.96.295-7.52v-2.012a4 4 0 0 0-.228-1.541 4 4 0 0 0-.792-1.333 3.9 3.9 0 0 0-1.234-.919 3.8 3.8 0 0 0-1.485-.362"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.024 56.644a2.93 2.93 0 1 0 0-5.86 2.93 2.93 0 0 0 0 5.86"
  })));
};
export default SvgTurbine;